import { render, staticRenderFns } from "./PaymentBought.vue?vue&type=template&id=4d540130&"
import script from "./PaymentBought.vue?vue&type=script&lang=js&"
export * from "./PaymentBought.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports